export enum LanguageCode {
  EN = 'en_US',
  GR = 'el_GR'
}
